import { Component, DestroyRef, OnInit, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { ApplicationModalComponent } from '../../../../../core/shared/components/modals/application-modal/application-modal.component';
import { Application } from '../../../../../core/shared/models/application.model';
import { GetApplicationsByUser } from '../../../../../core/shared/actions/application.actions';
import { ApplicationState } from '../../../../../core/shared/states/application.state';
import { LoadingSpinnerComponent } from '../../../../../core/shared/components/loading-spinner/loading-spinner.component';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
@Component({
  selector: 'app-developer-applications-list',
  templateUrl: './developer-applications-list.component.html',
  styleUrls: ['./developer-applications-list.component.scss'],
  standalone: true,
  imports: [
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    LoadingSpinnerComponent,
    MatInputModule,
    MatIcon,
    MatButton,
    MatIconButton,
  ],
})
export class ApplicationsDeveloperListComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  public paginator!: MatPaginator;
  public sort!: MatSort;
  public loading = true;
  public application!: Application;
  public applicationsCount = 0;
  public activeApplications = 0;
  public awaitingApplications = 0;
  public dataSource = new MatTableDataSource<Application>();
  public displayedColumns = ['icon', 'application_name', 'Description', 'approved', 'actions'];
  public readonly applicationsByUser: Observable<
    Application[]
  >;
  constructor(
    public store: Store,
    public modalService: NgbModal,
    public router: Router,
    public authService: AuthService
  ) {
    this.applicationsByUser = this.store.select(ApplicationState.getApplicationList);
    this.authService.getCurrentUser().then((user) => {
      this.store.dispatch(
        new GetApplicationsByUser(
          user.username.replace('DraexlmaierAzureAD_', '')
        )
      );
    });
  }

  ngOnInit(): void {
    this.applicationsByUser.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      this.dataSource.data = data;
      this.applicationsCount = data.length;
      this.activeApplications = data.filter((el) => el['approved'] === true).length;
      this.awaitingApplications = this.applicationsCount - this.activeApplications;
      this.loading = false;
    });
  }

  openModal(
    selectedApplication: Application,
    formMode: string,
    editApplication: boolean,
    admin: boolean
  ) {
    // Open modal form component
    const modalRef = this.modalService.open(ApplicationModalComponent, {
      size: 'lg',
    });
    // pass into form component variable
    modalRef.componentInstance.application = selectedApplication;
    modalRef.componentInstance.editApplication = editApplication;
    modalRef.componentInstance.admin = admin;
    // pass into form component variable
    // pass into form component variable formMode
    modalRef.componentInstance.formMode = formMode;
    // handle result passing back from modal form component
    //modalRef.result.then((event) => {});
  }

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  //search bar
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    // if (this.paginator && this.sort) {
    // }
  }
}
